import React from 'react';
const PageTitle = ({ text = '', text2 = '', fontSize = 20, center = false }) => (
  <div style={{ fontSize, lineHeight: '24px', letterSpacing: '0.0025em', color: '#064B6F', fontWeight: 500, display: 'flex', alignItems: 'center', justifyContent: center ? 'center' : '-moz-initial' }}>
    {text}
    {text2.length > 0 && <div style={{ fontSize: 16, color: 'gray' }}>{`_${text2}`}</div>}
  </div>
);
export default PageTitle;
